import { type FC } from "react";

import { Alert } from "@snapchat/snap-design-system";

import styles from "./ExclusiveLensToggle.module.css";
import {
    CannotEnableForLensPlusPayouts,
    InvalidLensForLensPlusPayouts,
    InvalidLensForLensPlusPayoutsDescription,
    LensPlusPayoutsPending,
    LensPlusPayoutsPendingDescription,
} from "./messages.generated";

interface ExclusiveLensValidationAlertProps {
    type: "error" | "warning" | "pending";
    errorMessage?: string;
}

export const ExclusiveLensValidationAlert: FC<ExclusiveLensValidationAlertProps> = ({ type, errorMessage }) => {
    if (type === "error") {
        return (
            <Alert
                className={styles.alertStyle}
                status="error"
                title={<InvalidLensForLensPlusPayouts />}
                description={<InvalidLensForLensPlusPayoutsDescription validationErrorMessage={errorMessage} />}
            />
        );
    }

    if (type === "warning") {
        return (
            <Alert
                className={styles.alertStyle}
                status="warning"
                title={<CannotEnableForLensPlusPayouts />}
                description={errorMessage}
            />
        );
    }

    return (
        <Alert
            className={styles.alertStyle}
            status="warning"
            title={<LensPlusPayoutsPending />}
            description={<LensPlusPayoutsPendingDescription />}
        />
    );
};
